import React from 'react';

import LaunchIcon from '@mui/icons-material/Launch';
import { Box, Link, ListItem } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import StyledList from './StyledComponents/StyledList';
import StyledListItemButton from './StyledComponents/StyledListItemButton';
import StyledListItemText from './StyledComponents/StyledListItemTextOption';
import StyledListSubheader from './StyledComponents/StyledListSubheader';

const ResourcesOptions = ({ handleClose }) => {
    const { t } = useTranslation();
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <StyledList
                subheader={
                    <StyledListSubheader>
                        {t('Resource', { count: 2 })}
                    </StyledListSubheader>
                }
            >
                <ListItem disablePadding>
                    <StyledListItemButton
                        component={Link}
                        href={`${import.meta.env.VITE_ACADEMY_URL}es/`}
                        onClick={handleClose}
                        target="_blank"
                    >
                        <StyledListItemText primary="Academy" />
                        <LaunchIcon fontSize="small" />
                    </StyledListItemButton>
                </ListItem>
            </StyledList>
        </Box>
    );
};

ResourcesOptions.propTypes = {
    handleClose: PropTypes.func,
};

export default ResourcesOptions;
